export const TOKEN = localStorage.getItem('token');;
export const ROLE = localStorage.getItem('user_role');
export const SHORTCODE = localStorage.getItem('shortc');
export const NAME = localStorage.getItem('name');
export const AGENTEKEYWORD = localStorage.getItem('username');
export const STATE = localStorage.getItem('state');


export const USERID = localStorage.getItem('useridd');